import type { EntitySupplementTag } from "@classes-service-types/entity-supplement-tag";
import type { ResponseBaseGetOneResponseEntitySupplementTag } from "@classes-service-types/response-base-get-one-response-entity-supplement-tag";
import { type UseQueryReturnType, useQuery } from "@tanstack/vue-query";
import type { AxiosResponse } from "axios";
import { computed, type Ref, unref } from "vue";
import hostInstitutionService from "@/services/hostInstitution";

export const useGetEntitySupplementById = (
  hostInstitutionId: Ref<string> | string,
): UseQueryReturnType<EntitySupplementTag, Error> => {
  const enabled = computed(() => Boolean(unref(hostInstitutionId)));
  const entitySupplementQueryKey = computed(() => ["entity-supplement", unref(hostInstitutionId)]);

  return useQuery<EntitySupplementTag, Error, EntitySupplementTag>({
    enabled: enabled,
    queryKey: entitySupplementQueryKey,
    queryFn: async (): Promise<EntitySupplementTag> => {
      const response: AxiosResponse<ResponseBaseGetOneResponseEntitySupplementTag> =
        await hostInstitutionService.getEntitySupplementById(unref(hostInstitutionId));
      return response.data.data.items;
    },
  });
};
